/**
 * @file Tabs.jsx
 * @author Archana
 * @date 2024-10-29
 * @description Component of DetailsPanel to manage tabs.
 */
import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";

export function TabList(props) {
  const { onChange, value, ...other } = props;
  return (
    <Tabs
      value={value}
      onChange={onChange}
      aria-label="custom tabs"
      TabIndicatorProps={{
        style: { display: "none" },
      }}
      sx={{
        mt: 1,
        display: "inline-flex",
        alignSelf: "flex-start",
        width: "auto",
        borderRadius: "80px",
        bgcolor: "#FDFDFD",
        "& .MuiTab-root.Mui-selected": {
          px: 4,
          borderRadius: "40px",
          bgcolor: "#FA8232",
          color: "#fff",
        },
      }}
      {...other}
    />
  );
}

TabList.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};
